import { pluralCategory } from "@app/league/utils/league-next-target";
import type { CountdownUnit } from "@app/league/utils/league-countdown";
import { formatLocalizedNumber } from "@core/shared/utils";
import { getCurrentLocaleCode, plainTrans } from "@mongez/localization";

/**
 * Number / plural helpers for League copy. All digits are 0-9 in both
 * languages (`formatLocalizedNumber` keeps ASCII glyphs).
 *
 * @example
 * const { num, points } = useLeagueFormat();
 * points(8); // "8 نقط"
 */
export function useLeagueFormat() {
  const lang = getCurrentLocaleCode();
  const num = (value: number) => formatLocalizedNumber(value);
  const points = (value: number) =>
    plainTrans(`league.pointsWord.${pluralCategory(value, lang)}`, {
      count: num(value),
    });
  const unit = (name: CountdownUnit, value: number) =>
    plainTrans(`league.units.${name}.${pluralCategory(value, lang)}`, {
      count: num(value),
    });
  const units = (parts: Array<{ unit: CountdownUnit; value: number }>) =>
    parts.map((part) => unit(part.unit, part.value)).join(plainTrans("league.units.join"));

  return { lang, num, points, unit, units };
}
